import Controller from "controllers/application_controller"

/**
 * Mounts a .ui-popover's content from its <template> when it opens and removes
 * it once the close transition ends, as Base UI's Popover does without
 * keepMounted. Controllers in the content connect on each open, so closed
 * popovers carry none of their markup or listeners.
 *
 *   <div class="ui-popover" popover data-controller="ui-popover">
 *     <template data-ui-popover-target="template">…</template>
 *   </div>
 *
 * The content mounts on beforetoggle, so a host's toggle handler finds its
 * controllers connected.
 */
export default class extends Controller {
  static identifier = "ui-popover"
  static targets = ["template"]

  connect() {
    this.addEventListener(this.element, "beforetoggle", event => this.beforeToggled(event))
    this.addEventListener(this.element, "toggle", event => this.toggled(event))
  }

  beforeToggled(event) {
    if (event.newState === "open" && !this.mounted) this.mount()
  }

  // getAnimations() lists the popover's own transitions and animations, or
  // none without motion. Reopening mid-fade cancels them, hence the recheck.
  async toggled(event) {
    if (event.newState === "open") return

    await Promise.allSettled(this.element.getAnimations().map(animation => animation.finished))
    if (!this.element.matches(":popover-open")) this.unmount()
  }

  // The template is the popover's only child while unmounted.
  get mounted() {
    return this.element.lastElementChild !== this.templateTarget
  }

  mount() {
    this.element.append(this.templateTarget.content.cloneNode(true))
  }

  unmount() {
    this.element.replaceChildren(this.templateTarget)
  }
}
